// extracted by mini-css-extract-plugin
export default {"button":"CloseButton_button__BvwMu","icon":"CloseButton_icon__e2Phm"};